"use strict";

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.string.starts-with");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ScopedStorage =
/*#__PURE__*/
function () {
  function ScopedStorage(scope, wrapped, persistent) {
    _classCallCheck(this, ScopedStorage);

    _defineProperty(this, "scope", void 0);

    _defineProperty(this, "wrapped", void 0);

    this.scope = "".concat(persistent ? ScopedStorage.GLOBAL_SCOPE_PERSISTENT : ScopedStorage.GLOBAL_SCOPE_VOLATILE, "_").concat(btoa(scope), "_");
    this.wrapped = wrapped;
  }

  _createClass(ScopedStorage, [{
    key: "scopeKey",
    value: function scopeKey(key) {
      return "".concat(this.scope).concat(key);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      this.wrapped.setItem(this.scopeKey(key), value);
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.wrapped.getItem(this.scopeKey(key));
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      this.wrapped.removeItem(this.scopeKey(key));
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this = this;

      Object.keys(this.wrapped).filter(function (key) {
        return key.startsWith(_this.scope);
      }).map(this.wrapped.removeItem.bind(this.wrapped));
    }
  }]);

  return ScopedStorage;
}();

exports.default = ScopedStorage;

_defineProperty(ScopedStorage, "GLOBAL_SCOPE_VOLATILE", 'nextcloud_vol');

_defineProperty(ScopedStorage, "GLOBAL_SCOPE_PERSISTENT", 'nextcloud_per');
//# sourceMappingURL=scopedstorage.js.map